import React from "react";
import * as aor from "react-admin";

// Restore when a real action is added
import StatusChip from "../../components/StatusChip";

import { POLICY_INSTALLATIONS } from "../../common/rolesManagement";
import { InstallationsGroupStatuses } from "../../common/statuses";
import MyChipField from "../../components/MyChipField";
import Cloud from "@material-ui/icons/Cloud";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Tooltip from "@material-ui/core/Tooltip";
import ExportButtonInst from "../../components/ExportButtonInst";
import TranslatedText from "../../components/TranslatedText";
import { getPolicies } from "../../common/authClient";
import HelpIcon from "@material-ui/icons/Help";
import InputAdornment from "@material-ui/core/InputAdornment";
import { isStaging } from "../../common/utilities";

const statusFilterChoices = Object.values(InstallationsGroupStatuses).map(
    groupStatus => ({
        id: groupStatus,
        name: `resources.installations.groupStatuses.${groupStatus}`
    })
);

const InstallationsActions = props => (
    <aor.CardActions>
        {props.permissions.includes(POLICY_INSTALLATIONS.EXPORT) && (
            <span>
                <ExportButtonInst />
            </span>
        )}
    </aor.CardActions>
);

const MyActivityField = props => {
    let activity_resource_name = "";
    let image = <CloudUpload />;
    const { record } = props;
    if (record && record.activity !== undefined) {
        activity_resource_name = `resources.tickets.activity_decoder.${record.activity}`;
        if (record.activity === "INSTALLATION") {
            image = <Cloud />;
        } else if (record.activity === "") {
            image = <div />;
        }
    }
    return (
        <Tooltip
            title={<TranslatedText resource_name={activity_resource_name} />}
        >
            {image}
        </Tooltip>
    );
};

const MyUrlField = () => {
    const suff = isStaging() === true ? ".cloudteamsys.com" : ".teamsystem.io";
    const tooltip_text =
        `To filter insert url except "https://" and "` + suff + `"`;
    return (
        <Tooltip
            placement="left"
            title={<TranslatedText resource_name={tooltip_text} />}
        >
            <HelpIcon
                style={{
                    verticalAlign: "center",
                    marginLeft: 20,
                    marginBottom: 3
                }}
            />
        </Tooltip>
    );
};

const getTypes = props => {
    if (Object.values(props.data)[0]) {
        let dati = Object.values(props.data)[0];
        let arr = dati["result_lic"];
        if (arr && Object.keys(arr).length !== 0) {
            return arr.map(installation_type => ({
                id: installation_type.id,
                name: installation_type.name
            }));
        }
    }
};

const Filter = props => (
    <aor.Filter {...props}>
        <aor.NumberInput label="Id" source="ids" alwaysOn />
        <aor.TextInput source="customer_name" alwaysOn />
        {props.permissions &&
            props.permissions.includes(POLICY_INSTALLATIONS.SHOW_COMPANY) && (
                <aor.TextInput source="company_name" alwaysOn={true} />
            )}
        <aor.TextInput
            source="access_url"
            alwaysOn={true}
            allowEmpty={true}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <MyUrlField />
                    </InputAdornment>
                )
            }}
        />
        <aor.SelectInput
            source="status"
            choices={statusFilterChoices}
            alwaysOn={true}
            allowEmpty={false}
        />

        <aor.SelectInput
            source="installation_type_id"
            choices={getTypes(props)}
            alwaysOn={true}
            allowEmpty={true}
        />
    </aor.Filter>
);

export default props => (
    <aor.List
        {...props}
        title="resources.installations.views.list.title"
        filters={<Filter permissions={getPolicies()} />}
        filterDefaultValues={{
            status:
                InstallationsGroupStatuses.inProgressAndCompletedInstallations,
            installation_types_by_company_id: true
        }}
        sort={{ field: "last_updated_at", order: "DESC" }}
        bulkActionButtons={false}
        actions={<InstallationsActions permissions={getPolicies()} />}
    >
        <aor.Datagrid>
            <aor.TextField source="id" label="Id" sortable={true} />

            <MyActivityField label="Attività" />
            <aor.ReferenceField
                label="resources.customers.nameSingular"
                source="customer_id"
                reference="customers"
                linkType={false}
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            {getPolicies() &&
                getPolicies().includes(POLICY_INSTALLATIONS.SHOW_COMPANY) && (
                    <aor.ReferenceField
                        reference="companies"
                        source="company_id"
                        linkType="show"
                        sortable={false}
                    >
                        <MyChipField source="name" {...props} />
                    </aor.ReferenceField>
                )}
            <aor.UrlField
                source="complete_installation_url"
                target="_blank"
                sortable={false}
            />
            <StatusChip
                source="status"
                translationRoot={"resources.events.types"}
                alwaysOn={true}
            />
            <aor.TextField
                source="installation_type_label"
                label="resources.installations.fields.installation_type_id"
            />
            <aor.DateField source="last_updated_at" showTime={true} />
            <aor.ShowButton />
        </aor.Datagrid>
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/Installations/List.js